import { render } from "./EmployerComonent.vue?vue&type=template&id=6b6bbfed&scoped=true"
import script from "./EmployerComonent.vue?vue&type=script&lang=js"
export * from "./EmployerComonent.vue?vue&type=script&lang=js"

import "./EmployerComonent.vue?vue&type=style&index=0&id=6b6bbfed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b6bbfed"]])

export default __exports__